<template>
  <Tree v-bind="$attrs" v-model:checkedKeys="checkedKeys" @check="check"> </Tree>
</template>
<script lang="ts" setup name="FormTree">
  import { ref } from 'vue'
  import { Tree, Form } from 'ant-design-vue'
  const formItemContext = Form.useInjectFormItemContext()
  interface Props {
    value: (string | number)[]
  }
  const props = defineProps<Props>()
  const checkedKeys = ref(props.value)

  const emit = defineEmits(['update:value'])
  const check = () => {
    emit('update:value', checkedKeys)
    formItemContext.onFieldChange()
  }
  const setCheckedKeys = (ids: any) => {
    checkedKeys.value = ids
  }
  defineExpose({
    setCheckedKeys
  })
</script>
